// extracted by mini-css-extract-plugin
export default {"highlight":"highlight_LvZgQ0cG"};